import { render } from "./Ref.vue?vue&type=template&id=68f83fa8"
import script from "./Ref.vue?vue&type=script&lang=js"
export * from "./Ref.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1919945302/src/app.tamildata.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__